import {
  compressToEncodedURIComponent,
  decompressFromEncodedURIComponent
} from 'lz-string';
import { getVersion } from './version';

export function getContentDataFromQuery(): {
  d: object;
  t?: string;
} | null {
  const search = globalThis.location.search;
  if (!search) {
    return null;
  }
  const params = new URLSearchParams(search);
  const dataQuery = params.get('s');
  if (!dataQuery) {
    return null;
  }
  try {
    const data = JSON.parse(decompressFromEncodedURIComponent(dataQuery));
    if (data.d) {
      return {
        d: data.d,
        t: data.t
      };
    }
    return { d: data };
  } catch (e) {
    return null;
  }
}

export function getQueryStringForData(data: object): string {
  return compressToEncodedURIComponent(JSON.stringify(data));
}

export function getShareUrlForData(data: object, title?: string): string {
  const baseUrl = window.location.origin + window.location.pathname;
  const queryString = getQueryStringForData({ d: data, t: title });
  const version = getVersion();
  if (version > 1) {
    return `${baseUrl}?v=${version}&s=${queryString}`;
  }
  return `${baseUrl}?s=${queryString}`;
}
